module.exports = __webpack_public_path__ + "img/EMS_user_manual19_Layout.f37fd392.png";